export class CustomerOrderBuildStepDetails {
  processName: string
  processStatus: number

  constructor(processName: string, processStatus: number) {
    this.processName = processName
    this.processStatus = processStatus
  }
}